/* eslint-disable import/prefer-default-export */

const formatNumber = (number, precision = 1) => {
  const numStr = number.toString()
  const numLen = numStr.length

  return number < 1000
    ? numStr
    : `${parseFloat(
        numStr.substr(0, (numLen - 1) % 3 + 1 + precision) / 10 ** precision
      )}${'KMB'[Math.floor((numLen - 1) / 3) - 1] || ''}`
}

export { formatNumber }



// WEBPACK FOOTER //
// ./src/utils/number.js